/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {FormStateInterface} from '@/store/modules/form/types';
import {RootState} from '@/store/types';

export const getters: GetterTree<FormStateInterface, RootState> = {

    /**
     * Gets the stage.
     *
     * @param {FormStateInterface} state
     *
     * @returns {number[]}
     */
  stage(state: FormStateInterface): number {
      return state.stage;
  },

    // todo change return type for reportStage getter
    /**
     * Gets the report stage 1.Report.
     *
     * @param {FormStateInterface} state
     *
     * @returns {any}
     */
    reportStage(state: FormStateInterface): any {
      return state.reportStage;
  },

};
